import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'next-icon',
    templateUrl: './next-icon.component.svg',
    styleUrl: './next-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NextIconComponent {}
